import type { NavItem } from '@/app/nav/collect'

/**
 * No entry of its own: the shell already declares "Calendar" (common nav, Calendar read) and "Trash" (common and
 * accounting navs, with the trash badge); the inbox became the chat (src/modules/messages).
 */
const nav: NavItem[] = []

export default nav
